export const MI_UPFRONT_PREMIUM_PERCENT_DECIMAL_SCALE = 3;

export const MI_PREMIUM_RATE_PERCENT_DECIMAL_SCALE = 4;

export const MI_TEXT_MAX_LENGTH = 100;

export const MI_RATE_PLACEHOLDER = '0.0000';

export const MI_MONTHS_PLACEHOLDER = 'Months';

export const MI_AMOUNT_PLACEHOLDER = '0.00';

export const MI_STORED_VALUE_CLEARED_MESSAGE = "Can't clear — enter a new value";

export const MI_ORDER_OUTCOME_FIELD_IDS = [
  'miApplicationType',
  'miOrderStatus',
  'miDecisionType',
  'miOrderedDate',
  'miDecisionDate',
  'miActivatedDate',
  'miCertificateIdentifier',
  'miCertificateExpirationDate',
  'miQuoteIdentifier',
  'miQuoteExpirationDate',
];
